import {
  Mail,
  MessageCircle,
  MessageSquare,
  PhoneIncoming,
  PhoneOutgoing,
  Send,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { t } from '@lingui/core/macro';
import type { EmployerContactLogOutcome, EmployerContactLogType } from '@duke-hq/svc-api-db/client';

// Icon and human label for each contact-log interaction type. The label is a
// function so the translation resolves at render time, not module load.
export const contactLogTypeMeta: Record<
  EmployerContactLogType,
  { icon: LucideIcon; label: () => string }
> = {
  INBOUND_CALL: { icon: PhoneIncoming, label: () => t`Inbound call` },
  OUTBOUND_CALL: { icon: PhoneOutgoing, label: () => t`Outbound call` },
  MEETING: { icon: Users, label: () => t`Meeting` },
  INBOUND_EMAIL: { icon: Mail, label: () => t`Inbound email` },
  OUTBOUND_EMAIL: { icon: Send, label: () => t`Outbound email` },
  INBOUND_SMS: { icon: MessageSquare, label: () => t`Inbound SMS` },
  OUTBOUND_SMS: { icon: MessageCircle, label: () => t`Outbound SMS` },
};

export const contactLogTypeOrder: EmployerContactLogType[] = [
  'INBOUND_CALL',
  'OUTBOUND_CALL',
  'MEETING',
  'INBOUND_EMAIL',
  'OUTBOUND_EMAIL',
  'INBOUND_SMS',
  'OUTBOUND_SMS',
];

export const contactLogResultMeta: Record<EmployerContactLogOutcome, { label: () => string }> = {
  SUCCESSFUL: { label: () => t`Successful` },
  UNSUCCESSFUL: { label: () => t`Unsuccessful` },
  NO_ANSWER: { label: () => t`No answer` },
  REQUESTED_CALLBACK: { label: () => t`Requested callback` },
};

export const contactLogResultOrder: EmployerContactLogOutcome[] = [
  'SUCCESSFUL',
  'UNSUCCESSFUL',
  'NO_ANSWER',
  'REQUESTED_CALLBACK',
];
